import { render, staticRenderFns } from "./edit_dialog.vue?vue&type=template&id=2bf9561d"
import script from "./edit_dialog.vue?vue&type=script&lang=js"
export * from "./edit_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports